<template>
  <div>
    <CategoryBlock />
    <ArticlesBlock
      @openArticle="(id) => $emit('openArticle', id)"
      articletype="category"
    />
  </div>
</template>

<script>
import CategoryBlock from '@/components/blocks/category/CategoryBlock.vue';
import ArticlesBlock from '@/components/blocks/articles/ArticlesBlock.vue';

export default {
  name: 'CategoryPage',
  components: {
    CategoryBlock,
    ArticlesBlock,
  },
};
</script>

<style lang="scss" scoped></style>
